import React from 'react';
import { Box, Typography, Button, Stack, Container, Card, CardContent, Chip } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPartnerDisplayName } from '../common/partnerUtils';
import PartnerMeta from '../components/PartnerMeta.jsx';

export default function PartnerUpsellPage({ partner }) {
  const navigate = useNavigate();
  const settings = useSelector(state => state.settingsdata.settings);
  const partnerName = getPartnerDisplayName(partner, settings) || 'Partner';
  const contactEmail = partner?.supportEmail || partner?.contactEmail || settings?.contact_email || settings?.CompanyEmail;
  const contactPhone = partner?.supportPhone || partner?.contactPhone || settings?.CompanyPhone;

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0b0b0b',
        color: '#fff',
        px: 3,
        py: 8,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <PartnerMeta partner={partner} title={`${partnerName} | Inactive`} />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 0.35,
          background:
            'radial-gradient(circle at 20% 20%, rgba(59,130,246,0.4), transparent 55%), radial-gradient(circle at 80% 10%, rgba(251,191,36,0.35), transparent 50%)',
        }}
      />
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 4,
            border: '1px solid rgba(255,255,255,0.12)',
            bgcolor: 'rgba(15,23,42,0.75)',
            boxShadow: '0 30px 60px rgba(0,0,0,0.35)',
            textAlign: 'center',
          }}
        >
          <CardContent sx={{ p: { xs: 3, md: 4 } }}>
            <Chip
              label="Subscription inactive"
              sx={{
                bgcolor: 'rgba(251,191,36,0.2)',
                color: '#fbbf24',
                fontWeight: 600,
                mb: 2,
              }}
            />
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
              {partnerName} is currently inactive
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.7)', mb: 3, fontSize: 18 }}>
              This partner page is not active. If you manage this business, contact us to enable
              bookings and unlock your branded booking page.
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
              <Button
                variant="contained"
                onClick={() => navigate('/contact-us')}
                sx={{
                  bgcolor: '#fff',
                  color: '#000',
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                  borderRadius: 999,
                  '&:hover': { bgcolor: '#f2f2f2' },
                }}
              >
                Contact sales
              </Button>
              {contactEmail ? (
                <Button
                  variant="outlined"
                  onClick={() => window.open(`mailto:${contactEmail}`, '_blank')}
                  sx={{
                    borderColor: 'rgba(255,255,255,0.5)',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 4,
                    py: 1.5,
                    borderRadius: 999,
                    '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' },
                  }}
                >
                  Email us
                </Button>
              ) : null}
              {contactPhone ? (
                <Button
                  variant="outlined"
                  onClick={() => window.open(`tel:${contactPhone}`, '_self')}
                  sx={{
                    borderColor: 'rgba(255,255,255,0.5)',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 4,
                    py: 1.5,
                    borderRadius: 999,
                    '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' },
                  }}
                >
                  Call us
                </Button>
              ) : null}
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
